import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SubNavigation.css';

/**
 * Componente de sub-navegação reutilizável para agrupar páginas relacionadas
 * 
 * @param {Array} items - Array de objetos com { path, label, icon? }
 */
const SubNavigation = ({ items }) => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="sub-navigation">
      <nav className="sub-nav-links">
        {items.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`sub-nav-link ${isActive(item.path) ? 'active' : ''}`}
          >
            {item.icon && <span className="sub-nav-icon">{item.icon}</span>}
            <span className="sub-nav-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default SubNavigation;

